import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, TextField, Grid } from "@material-ui/core";
import Form from "react-bootstrap/Form";
import Container from "@material-ui/core/Container";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import "alertifyjs/build/css/alertify.css";
import "../styles/stilo.css";
import SelectorSimpleCrear from "../SelectorSimpleCrear";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  button: {
    textAlign: "center",
    left: "90%",
    background: "silver",
  },
  buttonSubmit: {
    textAlign: "center",
    left: "35%",
    background: "silver",
  },

  valor: {
    cursor: "pointer",
    marginTop: theme.spacing(2),
    margin: theme.spacing(2),
  },

  formControl: {
    margin: theme.spacing(-2),
    minWidth: 250,
    Width: 300,
  },
  selectEmpty: {
    marginTop: theme.spacing(1),
  },

  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

const FormObjetivo = ({ onSubmit, nombre1, defaultData }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "all" });

  const classes = useStyles();
  const glosario = useSelector((state) => state.glosarios.value);

  return (
    <Form autoComplete="off">
      <Container>
        <Grid container align="center">
          <Grid sm={12}>
            <Form.Group className="mb-3" align="center">
              <TextField
                id="outlined-basic"
                label="Nombre"
                variant="standard"
                type="text"
                style={{ width: 400 }}
                aria-invalid={errors.name ? "true" : "false"}
                defaultValue={
                  defaultData && defaultData.nombre ? defaultData.nombre : ""
                }
                {...register("nombre", {
                  required: "Nombre es requerido",
                  pattern: {
                    value: /[A-Za-z0-9._%+-]/,
                    message: "Nombre es requerido",
                  },
                })}
              />
              <ErrorMessage
                errors={errors}
                name="nombre"
                render={({ message }) => <p>{message}</p>}
              />
            </Form.Group>
          </Grid>

          <Grid sm={12}>
            <Form.Group className="mb-3" align="center">
              <TextField
                id="outlined-basic"
                label="Definición"
                variant="standard"
                type="text"
                multiline
                rows={5}
                style={{ width: 400 }}
                defaultValue={
                  defaultData && defaultData.definicion
                    ? defaultData.definicion
                    : ""
                }
                {...register("definicion", {
                  required: "Definición es requerido",
                })}
              />
              <ErrorMessage
                errors={errors}
                name="definicion"
                render={({ message }) => <p>{message}</p>}
              />
            </Form.Group>
          </Grid>

          <Grid sm={12}>
            <Form.Group className="mb-3" align="center">
              <SelectorSimpleCrear
                register={register}
                name={"Glosario"}
                obj={glosario}
                glosario={
                  defaultData && defaultData.glosario
                    ? defaultData.glosario
                    : "2"
                }
              />
            </Form.Group>
          </Grid>
          <Grid sm={12}>
            <Form.Group className="mb-3" align="center">
              <TextField
                id="outlined-basic"
                label="Fuente"
                variant="standard"
                type="text"
                style={{ width: 400 }}
                defaultValue={
                  defaultData && defaultData.fuente ? defaultData.fuente : ""
                }
                {...register("fuente", {})}
              />
            </Form.Group>
          </Grid>
        </Grid>
      </Container>
      <div className={classes.root} align="center">
        <Button
          variant="contained"
          disabled={nombre1}
          onClick={handleSubmit(onSubmit)}
        >
          Aceptar
        </Button>
      </div>
    </Form>
  );
};
export default FormObjetivo;
